/**
 * Copyright 2018 OpenStack Foundation
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * */
import {
  createAction,
  authErrorHandler
} from "openstack-uicore-foundation/lib/utils/actions";
import { CODE_200 } from "../utils/constants";

export const SET_SNACKBAR_MESSAGE = "SET_SNACKBAR_MESSAGE";
export const CLEAR_SNACKBAR_MESSAGE = "CLEAR_SNACKBAR_MESSAGE";

export const clearSnackbarMessage = () => (dispatch) => {
  dispatch(createAction(CLEAR_SNACKBAR_MESSAGE)({}));
};

export const setSnackbarMessage = (message) => (dispatch) => {
  dispatch(createAction(SET_SNACKBAR_MESSAGE)(message));
};

export const snackbarErrorHandler = (err, res) => (dispatch, state) => {
  authErrorHandler(err, res, setSnackbarMessage)(dispatch, state);
};

export const snackbarSuccessHandler = (message) => (dispatch, state) =>
  setSnackbarMessage({ ...message, type: "success", code: CODE_200 })(
    dispatch,
    state
  );

// eslint-disable-next-line no-unused-vars
export const ignoreErrorHandler = (err, res) => (dispatch, state) => {
  // do nothing
};
